export default function Blurred({ children, opacity = 0.3 }) {
    return (
        <div style={{ opacity: opacity, position: 'relative' }}>
            <div style={{ position: 'absolute', left: '0px', top: '0px', width: '100%', height: '100%' }}></div>
            { children }
        </div>
    )
}